import { apiCaller } from "../api-caller";
import { ENDPOINTS, REQUEST_TYPES } from "../constants";

export const getHomeCareBulkOrdersByReferenceAPI = bulkReference =>
  apiCaller({
    method: REQUEST_TYPES.GET,
    url: `${ENDPOINTS.ORDERS}homecare/bulk-reference/${encodeURIComponent(
      bulkReference
    )}/orders/`
  });

export const cancelHomeCareBulkOrdersAPI = data =>
  apiCaller({
    method: REQUEST_TYPES.POST,
    url: `${ENDPOINTS.ORDERS}homecare/bulk-cancel/`,
    data
  });
